class MeetingSettings{
    public roomId: string = '';
    public sessionId: string = '';
    public token: string = '';
    public autoStartRecording: boolean = false;
    public isVirtualBackgroundActive: boolean = false;
    public virtualBackgroundImageUrl: string = '';
    public logoUrl: string = '';
    public activeCameraId: string = '';
    public isCameraRequired: boolean = false;
    public disableTorch: boolean = false;
    public isVirtualBackgroundSupported: boolean = false;
    public isBlurSupported: boolean = false;
    public defaultCameraOff: boolean = false;
    public defaultMicrophoneOff: boolean = false;
    public shouldDefaultToBackCameraOnMobile: boolean = false;
    public spotlightVisitor: boolean = false;
    public pingUrl: string = ''
}
export default MeetingSettings;
export { MeetingSettings };